import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-create-enrollment',
  templateUrl: './create-enrollment.component.html',
  styleUrls: ['./create-enrollment.component.scss']
})
export class CreateEnrollmentComponent implements OnInit {

  constructor(private service: ApiService, private toast:ToastClientService, private config: ApiConfiguration) { }
  public productImage;
  public productImage1;
  public program_id = 1;
  public tse_id;
  public outlet_name;
  public owner_name;
  public mobile;
  public distrubutor_ids;
  public birth_date;
  public anniverary_date;
  public address_line1;
  public address_line2;
  public city_name;
  public state_code;
  public pincode;
  public gst_number;
  public document_type;
  public document_file:any;
  public store_file_1:any;
  public store_file_2:any;
  public user_role_id;
  public longitude;
  public latitude;
  public store_type;
  public tseList;
  public btn = false;
  public selectedDist=[];
  public dropdownList=[];
  public dropdownSettings;
  public selectedItems = [];
  public cities;
  public states;


  ngOnInit() {
    this.getUsersByRole(18);
    this.getUsersByRoleTSE();
    this.getCitieAndStates();
  }


  
  getUsersByRole(roleId) {
    let postdata= {
      "filter_search_geography": [],
      "filter_search_channel": [],
      "filter_search_region": [],
      "filter_search_userrole":[roleId]
    };
    this.service.post(this.config.getUserAssignment,postdata)
      .subscribe((res: any) => {
        this.dropdownList = res.body.data;
   
      console.log('Contest data is here')    

        console.log(this.dropdownList)    
      }, err => {
        console.log(err);
      })
  }


  imageChange(img){
    console.log(img)
    var file = img.target.files[0];
    var reader = new FileReader();
    var self = this;
    reader.onloadend = function() {
      self.productImage = reader.result;
    }
      reader.readAsDataURL(file);
  
    }
    storeimageChange(img){
      console.log(img)
      var file = img.target.files[0];
      var reader = new FileReader();
      var self = this;
      reader.onloadend = function() {
        self.productImage1 = reader.result;
      }
        reader.readAsDataURL(file);
    
    }

    submit(){
      let payload = {
        program_id: this.program_id,
        tse_id:this.tse_id,
        outlet_name:this.outlet_name,
        owner_name:this.owner_name,
        mobile:this.mobile,
        distrubutor_ids: this.selectedDist.toString(),
        birth_date:this.birth_date,
        anniverary_date:this.anniverary_date,
        address_line1:this.address_line1,
        address_line2:this.address_line2,
        city_name:this.city_name,
        state_code:this.state_code,
        pincode:this.pincode,
        gst_number:this.gst_number,
        document_type:this.document_type,
        document_file:this.productImage,
        store_file_1: this.productImage1,
        store_file_2:this.store_file_2,
        user_role_id:this.user_role_id,
        longitude:this.longitude,
        latitude:this.latitude,
        store_type: this.store_type
      }
      console.log(payload)
      this.service.postWithFormData(this.config.createEnroll, payload)
      .subscribe((res:any)=>{
        if(res.status == 200){
          this.btn = true;
          this.toast.Success("Saved")
        }else{
          console.log(res)
        }
      })
    }
    onDistSelect(event){
      this.selectedDist = [];
      this.selectedItems.forEach((entry)=> {
        this.selectedDist.push(entry.id);
    } )
    }

    
  getUsersByRoleTSE() {
    let postdata= {
      "filter_search_geography": [],
      "filter_search_channel": [],
      "filter_search_region": [],
      "filter_search_userrole":[4]
    };
    this.service.post(this.config.getUserAssignment,postdata)
      .subscribe((res: any) => {
        this.tseList = res.body.data;
   
      console.log('tseList data is here')    

        console.log(this.tseList)    
      }, err => {
        console.log(err);
      })
  }

  getCitieAndStates() {
    this.service.get(this.config.configGetCities)
      .subscribe((res: any) => {
        this.cities = res.data.cities;
        this.states = res.data.state_list;

        console.log(res.data)
      }, err => {
        console.log(err);
      })
  }



}
